import { UrlConst } from 'src/app/shared/constants/url-const';
import { Sensor } from 'src/app/shared/interfaces/sensor';
import { Site } from 'src/app/shared/interfaces/site';
import { LoadingService } from 'src/app/shared/services/loading.service';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SensorListTableService } from '../sensor-list-table/sensor-list-table.service';
import { SensorWbgtFormService } from './sensor-wbgt-form.service';

@Component({
  selector: 'app-sensor-wbgt-form',
  templateUrl: './sensor-wbgt-form.component.html',
  styleUrls: ['./sensor-wbgt-form.component.scss'],
})
export class SensorWbgtFormComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private sensorWbgtFormService: SensorWbgtFormService,
    private sensorListTableService: SensorListTableService
  ) {}

  @Input() sensor: Sensor | null = null;
  @Output() registered = new EventEmitter<boolean>();
  @Output() canceled = new EventEmitter<boolean>();

  errors: string[] = [];
  siteId: string | null = null;
  site: Site | null = null;
  sensors: Sensor[] | null = null;

  isUpdate: boolean = false;

  form = this.formBuilder.group({
    sensorId: ['', [Validators.required]],
    positionName: ['', [Validators.required]],
  });
  get sensorId() {
    return this.form.get('sensorId');
  }
  get positionName() {
    return this.form.get('positionName');
  }

  async ngOnInit() {
    this.sensorWbgtFormService.addLog();

    this.route.paramMap.subscribe((params) => (this.siteId = params.get('id')));

    if (!this.sensorWbgtFormService.isValidUser()) {
      console.log('user is not sysadmin or general');
      this.router.navigate([UrlConst.SLASH + UrlConst.PATH_SIGN_IN]);
      return;
    }

    if (this.sensorWbgtFormService.isGeneralGroup()) {
      console.log('user is general');
      const account = this.sensorWbgtFormService.getUser();
      if (account === null) {
        console.log('account is null');
        this.router.navigate([UrlConst.SLASH + UrlConst.PATH_SIGN_IN]);
        return;
      }
      if (this.siteId !== account.user) {
        console.log('siteId != user');
        this.router.navigate([UrlConst.SLASH + UrlConst.PATH_SIGN_IN]);
        return;
      }
    }

    if (this.siteId === null) {
      this.router.navigate([UrlConst.SLASH + UrlConst.PATH_SITE_CONFIG]);
      return;
    }

    this.site = await this.sensorWbgtFormService.getSiteWithOrganization(
      this.siteId
    );

    if (this.site === null) {
      this.router.navigate([UrlConst.SLASH + UrlConst.PATH_SITE_CONFIG]);
      return;
    }

    // フォームのプルダウンリスト作成（未使用センサー）
    const sensors: Sensor[] | null =
      await this.sensorWbgtFormService.getNoConfigSensorsWithOrganization();

    this.sensors = sensors;

    // センサーが指定されていたら更新モード
    if (
      this.sensor !== null &&
      this.sensor.id !== undefined &&
      this.sensors !== null
    ) {
      this.isUpdate = true;

      // 未使用センサーに今のセンサーを追加する
      const usedSensor = await this.sensorWbgtFormService.getSensor(
        this.sensor.id
      );
      this.sensors.unshift(usedSensor!);

      this.form.setValue({
        sensorId: this.sensor.id,
        positionName: this.sensor.positionName ? this.sensor.positionName : '',
      });
    } else {
      this.isUpdate = false;
    }

    console.log('onInit', this.isUpdate);
  }

  async onSubmit() {
    try {
      this.loadingService.startLoading();

      // 更新でIDが変わっている場合は一旦古いセンサーを削除する
      if (this.isUpdate) {
        if (this.sensor === null) {
          this.registered.emit(false);
          return;
        }

        // センサー変更の時は一旦今のセンサー情報を削除して、後に控える登録処理を実行する
        if (this.sensorId?.value !== this.sensor.id) {
          try {
            await this.sensorListTableService.deleteSensor(
              this.site!,
              this.sensor!
            );
          } catch (error) {
            console.log('SiteConfigPageComponent.deleteConfig(): ', error);
            return;
          }
        }
      }

      // 設置場所の文言だけの変更
      await this.sensorWbgtFormService.setSensorToSite(
        this.site!,
        this.sensorId?.value,
        this.positionName?.value
      );

      this.registered.emit(true);
      if (this.isUpdate === true) {
        this.isUpdate = false;
        this.sensor = null;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingService.stopLoading();
    }
  }

  cancel() {
    this.isUpdate = false;
    this.sensor = null;

    this.canceled.emit(true);
  }
}
